<template>
    <section class="title">
        <h2>{{ dealName }}</h2>
        <a href="javascript:void(0);" @click="showProductTc">切换产品</a>
    </section>
</template>

<style lang="postcss">
    :root {
        --blueColor: #2A99F1;
    }
    .title {
        height: 46px;
        line-height: 46px;
        background-color: #FFF;
        padding: 0 30px;
        border-radius: 2px;
        & > h2 {
            display: inline-block;
            max-width: 60%;
            height: 100%;
            line-height: 46px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            vertical-align: top;
            font-size: 16px;
            font-weight: normal;
            margin: 0;
        }
        & > a {
            float: right;
            width: 80px;
            color: var(--blueColor);
            background: url(~static/img/search.png) no-repeat left center;
            text-indent: 20px;
        }
    }
</style>

<script>
    export default {
        data () {
            return {
            }
        },
        props: ['dealName'],
        methods: {
            // 显示切换产品弹层
            showProductTc () {
                this.$emit('showProductTc')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Title.vue?61da30bb